import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Typography from '@material-ui/core/Typography';
import messages from 'aurora-translations';

import ActionBar from './ActionBar';

const initialState = {
  passportNumber: null,
  nationality: null,
  email: null,
  mobileNumber: null,
};

const Filters = props => {
  const { classes, locale, loading, hiddenFilters, query, handleQueryChange, nationalities } = props;

  const [formData, setFormData] = useState(initialState);

  return (
    <>
      {/* Title */}
      <div className={classes.titleHead}>
        <Typography variant='h5' component='h1' className={`${classes.title} ${classes.fontWeight600} `}>
          <FormattedMessage {...messages.search_for_non_UAE_resident_buyer} />
        </Typography>
      </div>

      {/* Action Bar */}
      <ActionBar
        locale={locale}
        loading={loading}
        hiddenFilters={hiddenFilters}
        query={query}
        initialFormState={initialState}
        formData={formData}
        setFormData={setFormData}
        handleQueryChange={handleQueryChange}
        nationalities={nationalities}
      />
    </>
  );
};

Filters.propTypes = {
  classes: PropTypes.object.isRequired,
  locale: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  hiddenFilters: PropTypes.array.isRequired,
  query: PropTypes.object.isRequired,
  handleQueryChange: PropTypes.func.isRequired,
  nationalities: PropTypes.array,
};

Filters.defaultProps = {
  nationalities: [],
};
export default Filters;
